import { Component } from '@angular/core';
import { TranslationsService } from '../translations/translations.service';
import { AnalyticsService } from '../analytics.service';

@Component({
    selector: 'app-cookie-consent',
    templateUrl: './cookie-consent.component.html',
    styleUrls: ['./cookie-consent.component.scss'],
    standalone: false
})
export class CookieConsentComponent {
  showCookieBar = !localStorage.getItem('cookiesAccepted');

  constructor(
    public _translationService: TranslationsService,
    private analytics: AnalyticsService,
  ) {}

  acceptCookies(): void {
    localStorage.setItem('cookiesAccepted', 'true');
    this.showCookieBar = false;
    this.analytics.trackUiInteraction('cookie_consent_accept');
  }
}
